module.exports = __webpack_public_path__ + "img/plastic.a6185bf9.png";